<template>
  <div class="themeBody" :data-theme="themeMode">
  <div class="mainBoxForm" :class="{ 'mainBoxFormHigher': errorMsg }">

    <div class="centerBox">
      <go-back-button :back-url="'/account/login'">
        <template v-slot:body>
          <div class="goBackButtonBody">
            <el-image
                class="qidiLogo"
                :src="require('@/assets/logo.png')"
                :fit=" 'cover' "></el-image>
            <div class="cardBoxTitle">
              {{ $t('h.register.registerAnAccount') }}
            </div>
          </div>
        </template>
      </go-back-button>

      <div class="registerFormBox">
          <el-form :model="ruleForm" ref="ruleForm" :rules="rule">
            <div class="empty-height"></div>

            <el-form-item prop="userName">
              <el-input v-model="ruleForm.userName" :placeholder="$t('h.common.username')+'*'" clearable></el-input>
            </el-form-item>

            <el-form-item prop="userEmail">
              <el-input v-model="ruleForm.userEmail" :placeholder="$t('h.common.email')+'*'" clearable></el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input v-model="ruleForm.password" :placeholder="$t('h.common.password')+'*'" autocomplete="off"
                        :type="showPassword ? 'text' : 'password'">
                <i slot="suffix" @click="switchPassword">
                  <img
                      v-if="showPassword"
                      class="input_icon"
                      :src="require('@/assets/icons/password_show.png')"
                  />
                  <img
                      v-else
                      class="input_icon"
                      :src="require('@/assets/icons/password_hide.png')"
                  />
                </i>
              </el-input>
            </el-form-item>

            <el-form-item prop="emailCode">
              <el-input v-model="ruleForm.emailCode" :placeholder="$t('h.common.verificationCode')+'*'"
                        autocomplete="off" clearable
              >
                <template #suffix>
                  <el-button class="sendCodeBtn" @click="sendVerificationCode"
                             :disabled="isSendingCode || codeCountDown > 0">
                    {{
                      isSendingCode ? $t('h.common.Sending') + '...' : (codeCountDown > 0 ? `${codeCountDown}` + 's' : $t('h.common.sendVerificationCode'))
                    }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>

            <error-msg :errorMsg="errorMsg"/>

            <el-form-item style="margin-top: 20px">
              <el-button type="primary" class="subBtn" @click="submitForm('ruleForm')">{{ $t('h.register.register') }}
              </el-button>
            </el-form-item>

          </el-form>
        </div>

      <div class="pageFooter">
        <area-select-footer v-show="$store.state.isInSlicer==false"/>
        <copyright/>
      </div>

    </div>
  </div>
  </div>
</template>

<script>
import {register, sendEmail} from "@/api/api"
import {translateResMessage} from "~/utils/translateResMessage";

export default {
  data() {
    // 再次确认密码验证
    var validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    return {
      errorMsg: '',//错误提示信息
      showPassword: false,// 是否显示密码
      isSendingCode: false,//是否在发送验证码
      codeCountDown: 0,//验证码发送倒计时
      isActiveSub: false,//是否可以点击提交按钮
      ruleForm: {
        userName: '',
        userEmail: '',
        password: '',
        emailCode: '',
      },
      rule: {
        userName: [
          {required: true, message: this.$t('h.common.userNameRequired'), trigger: 'blur'},
        ],
        userEmail: [
          {required: true, message: this.$t('h.common.userEmailRequired'), trigger: 'blur'},
          {type: 'email', message: this.$t('h.common.userEmailInvalid'), trigger: ['blur', 'change']}
        ],
        password: [
          {required: true, message: this.$t('h.common.passwordInputLabel'), trigger: 'blur'},
          {min: 6, max: 20, message: this.$t('h.common.passwordInputLengthErrorLabel'), trigger: ['blur', 'change']},
        ],
        emailCode: [
          {required: true, message: this.$t('h.common.emailCodeRequired'), trigger: 'blur'},
        ],
      }
    }
  },
  methods: {
    //密码切换显示
    switchPassword() {
      this.showPassword = !this.showPassword;
    },
    submitForm(formName) {
      this.errorMsg = ""
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          formData.append('nick_name', this.ruleForm.userName);
          formData.append('email', this.ruleForm.userEmail);
          formData.append('password', this.ruleForm.password);
          formData.append('code', this.ruleForm.emailCode);
          formData.append('real_name', "");
          formData.append('sur_name', "");
          register(formData).then(res => {
            console.log(res)
            if (res.status === 0) {
              //this.$notify.success({
              //   title: this.$t('h.common.tip'),
              //   message: this.$t('h.common.registerSuccess'),
              // })
              this.setToken = res.data.token
              console.log('登录成功，准备存放token', this.setToken);
              localStorage.setItem("token", this.setToken)
              this.$router.push('/account/localLogin')
            } else {
              let result=translateResMessage(res.message)
              this.errorMsg = this.$t(result)
              //this.$notify.error({
              //   title: this.$t('h.common.tip'),
              //   message: this.errorMsg,
              // })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //发送验证码
    sendVerificationCode() {
      this.$refs.ruleForm.validateField('userEmail', (errorBackMsg) => {
        if (errorBackMsg) {
          console.warn("errorBackMsg",errorBackMsg)
          // 验证未通过，显示错误信息
          //this.$notify.error({
          //   title: this.$t('h.common.tip'),
          //   message: errorBackMsg,
          // })
          return
        } else {
          // 验证通过，准备发送
          if (this.codeCountDown > 0 || this.isSendingCode) {
            return; // 防止重复点击发送
          }
          this.isSendingCode = true;

          let formData = new FormData();
          formData.append('email', this.ruleForm.userEmail);
          formData.append('type', '3');
          sendEmail(formData).then(res => {
            if (res.status === 0) {
              console.log('发送验证码成功', res);
              this.startCountdown();
              //this.$notify.success({
              //   title: this.$t('h.common.tip'),
              //   message: this.$t('h.common.emailCodeSentSuccess'),
              // });
            } else {
              let result=translateResMessage(res.message)
              this.errorMsg = this.$t(result)
              //this.$notify.error({
              //   title: this.$t('h.common.tip'),
              //   message: this.errorMsg,
              // })
            }
            this.isSendingCode = false;
          })
        }
      });
    },
    //验证码倒计时 从点击按钮开始计算 也可以改成从发送成功开始计算
    startCountdown() {
      this.codeCountDown = 60;
      const timer = setInterval(() => {
        this.codeCountDown--;
        if (this.codeCountDown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    }
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

.mainBoxForm {
  @include background_color("background_color");
  @include font_color("text-color");
}

>>> .registerFormBox {
  width: 330px;
  margin: 0 auto;

  .subBtn {
    width: 100%;
    @include background_color("qidi_blue");
  }

  .footer {
    color: #757575;
    font-size: 10px;
    margin-top: 40px;
  }


  .el-input__inner {
    height: 25px;
    border-radius: 0px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;
    padding: 0; /* 确保 padding 设置为 0 */
    margin: 0; /* 确保 margin 设置为 0 */
    /*outline: medium;*/
    @include font_color('text-color');
    @include background_color("background_color");
  }

  .el-input__inner::placeholder {
    @include font_color("elInputPlaceholderColor");
  }
  .el-input__inner:focus {
    border-bottom-width: 2px;
    @include border_color("elInputBorderFocusColor");
  }

  .sendCodeBtn {
    border: none;
    color: #ACACAC;
    padding: 0;
    @include background_color('background_color');
    font-size: 12px;
  }

  .input_icon {
    cursor: pointer;
    width: 24px;
    padding-top: 8px;
    padding-right: 6px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/account/register.vue